export default {
  methods: {
    getSrc(imageName)
    {
      if (imageName)
      {
        try
        {
          return require('../assets/' + imageName)
        }
        catch (e)
        {
          console.log('failed open ' + imageName, e)
        }
      }
    }
  }
}
